var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch2Line(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10C11.2091 10 13 8.20914 13 6C13 3.79086 11.2091 2 9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10ZM12 14C12 12.8954 12.8954 12 14 12C15.1046 12 16 12.8954 16 14C16 15.1046 15.1046 16 14 16C12.8954 16 12 15.1046 12 14ZM14 10C11.7909 10 10 11.7909 10 14C10 16.2091 11.7909 18 14 18C14.7418 18 15.4364 17.7981 16.0319 17.4462L17.2928 18.7071C17.6834 19.0976 18.3165 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.707 17.2929L17.4461 16.032C17.7981 15.4365 18 14.7418 18 14C18 11.7909 16.2091 10 14 10ZM3.20272 12.458C4.53775 11.7422 6.44037 11.0391 8.80178 11.0016C8.29184 11.8838 8 12.9078 8 14C8 15.5367 8.5777 16.9385 9.52778 18H2.30248C1.58314 18 1 17.4169 1 16.6975C1 14.9703 1.68053 13.2741 3.20272 12.458Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch2Line);
export default __webpack_public_path__ + "static/media/search-2-line.92e07b9c6c28ef3af72ffa75e93585b9.svg";
export { ForwardRef as ReactComponent };